<template>
  <ModuleWrapper
    :moduleId="moduleId"
    :image="imageSrcPath('assets/branding/button-card-color.svg')"
    title="Name Card"
    @initializeData="initializeData"
  >
    <template #main>
      <StudioToggleWithLabel
        id="name-card-toggle"
        label="Name Cards"
        :checked="isNameCardEnable"
        @update:checked="toggleNameCard"
      />
      <template v-if="isNameCardEnable">
        <StudioSelect
          id="card-type-picker"
          label="Card Type"
          :options="[
            { value: '20px', label: 'Rounded' },
            { value: '10px', label: 'Rectangular' },
            { value: 'transparent', label: 'No Background' }
          ]"
          size="small"
          orientation="horizontal"
          class="tw-mb-4 tw-mt-4"
          :value="nameCardType"
          @change="onSelectCardType"
        />
        <StudioToggleWithLabel
          id="show-speaker-title-toggle"
          label="Show Speaker Title &amp; Company"
          class="tw-mb-4"
          :checked="showSpeakerTitle"
          @update:checked="toggleSpeakerTitle"
        />
      </template>
    </template>
  </ModuleWrapper>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';

import ModuleWrapper from './ModuleWrapper.vue';

import { StudioSelect, StudioToggleWithLabel } from '@/studioComponents';

export default {
  name: 'NameCardV2',
  components: {
    ModuleWrapper,
    StudioToggleWithLabel,
    StudioSelect
  },
  props: {
    moduleId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isNameCardEnable: true,
      nameCardType: '20px',
      showSpeakerTitle: false
    };
  },
  created() {
    this.initializeData();
  },
  computed: {
    ...mapGetters('branding', {
      getInitialModuleData: 'getInitialModuleData'
    })
  },
  methods: {
    ...mapMutations('branding', ['setChangesMadeInThemeObj']),
    initializeData() {
      const moduleKeys = ['name_card_type', 'name_card_display', 'name_card_radius', 'name_card_title_display'];
      const {
        name_card_type: nameCardType,
        name_card_display: nameCardDisplay,
        name_card_radius: nameCardRadius,
        name_card_title_display: nameCardTitleDisplay
      } = this.getInitialModuleData(moduleKeys);

      this.themeColors = {
        themeSecondaryColor: 'var(--theme-secondary-color)',
        secondaryTextColor: 'var(--secondary-text-color)'
      };

      // setting the initial inputs state
      this.isNameCardEnable = nameCardDisplay ? nameCardDisplay === 'block' : true;
      this.nameCardType = nameCardType ? nameCardType : '20px';
      this.showSpeakerTitle = nameCardTitleDisplay === 'visible';
    },
    toggleNameCard(event) {
      const value = event.target.checked;
      this.isNameCardEnable = value;
      // resetting the inputs to default state
      this.nameCardType = '20px';
      this.nameCardRadius = '20px';
      this.showSpeakerTitle = false;
      const payload = this.getToggleNameCardPayload();
      this.setChangesMadeInThemeObj(payload);
    },
    toggleSpeakerTitle(event) {
      const value = event.target.checked;
      this.showSpeakerTitle = value;
      this.setChangesMadeInThemeObj({
        name_card_title_display: value ? 'visible' : 'none'
      });
    },
    onSelectCardType(e) {
      const selectedCardType = e.target.value;
      this.nameCardType = selectedCardType;

      // When transparent is selected, set background to transparent
      // When radius is selected (20px, 10px), set the border-radius
      if (selectedCardType === 'transparent') {
        this.setChangesMadeInThemeObj({
          name_card_type: selectedCardType,
          name_card_background: 'transparent'
        });
      } else {
        this.setChangesMadeInThemeObj({
          name_card_type: selectedCardType,
          name_card_background: 'var(--theme-secondary-color)',
          name_card_text_color: 'var(--secondary-text-color)',
          name_card_radius: selectedCardType
        });
      }
    },
    getToggleNameCardPayload() {
      if (this.isNameCardEnable) {
        return {
          name_card_title_display: 'none',
          name_card_display: 'block',
          name_card_type: '20px',
          name_card_radius: '20px',
          name_card_background: 'var(--theme-secondary-color)',
          name_card_text_color: 'var(--secondary-text-color)'
        };
      }
      return {
        name_card_title_display: null,
        name_card_display: 'none',
        name_card_type: this.nameCardType,
        name_card_radius: this.nameCardRadius,
        name_card_background: 'transparent'
      };
    }
  }
};
</script>
